/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_TemplateInputs */

const en_entity_template = /** @type {(inputs: Entity_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template`)
};

const de_entity_template = /** @type {(inputs: Entity_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlage`)
};

/**
* | output |
* | --- |
* | "Template" |
*
* @param {Entity_TemplateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_template = /** @type {((inputs?: Entity_TemplateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_TemplateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_template(inputs)
	return de_entity_template(inputs)
});